import createClient from '@economic/http-client';
import { AxiosInstance } from 'axios';

let api: AxiosInstance | null = null;

export function setupAiBroEndpoint() {
    api = createClient('https://ai-bro.e-conomic.net/message', undefined, undefined);
}

export default function getApi() {
    if (!api) {
        throw new Error('Call setupAiBroEndpoint before using addons API');
    }

    return api;
}
